import createEditTagRedux from 'Modules/tags/.components/createEditTag/redux/reducer'
import deleteTagsRedux from 'Modules/tags/.components/deleteTag/redux/reducer'
import bulkTagsRedux from 'Modules/tags/.components/bulkTags/redux/reducer'


export default {
    createEditTagRedux,
    deleteTagsRedux,
    bulkTagsRedux
}